import { render } from "./ProgressBar.vue?vue&type=template&id=f54077e0"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"

import "./ProgressBar.vue?vue&type=style&index=0&id=f54077e0&lang=scss"

import exportComponent from "/builds/rahmet/products/grading-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__